'use strict';

/**
 *
 * @name: GeneralStoryTemplateDirective
 *
 */

import DirectiveTemplate from './general-story-template.directive.html';

function GeneralStoryTemplateDirective() {

  'ngInject';

  return {
    template: DirectiveTemplate,
    link: function(scope, element, attrs) {
      if (attrs.storyTemplateType) {
        scope.stt = attrs.storyTemplateType;
      }

      if (attrs.storyTemplateAnalytics) {
        scope.sttAnalytics = attrs.storyTemplateAnalytics;
      }

    }
  };
}

export default GeneralStoryTemplateDirective;



// WEBPACK FOOTER //
// ./app/pages/story/general-story-template.directive.js